import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { LazySourcingDomainSelectionDrawer } from '@fiverr-private/expert_sourcing_domain_selection_drawer';
import { BriefCreationDrawer } from '@fiverr-private/dm_brief_creation';
import { rollouts, currencies } from '../../PropTypes';
import withContext from '../../lib/withContext';
import { usePricingDataContext } from '../../contexts/PricingDataContext';
import Nav from '../../lib/Nav';
import Layout from '../../components/Layout';
import Row from '../../components/Row';
import { BusinessSidebarTrigger } from '../../components/BusinessSidebarTrigger';
import BusinessNavSearch from '../../components/BusinessNavSearch';
import { FiverrBusinessProLinkLogo } from '../../components/FiverrBusinessProLinkLogo';
import { BusinessProJoinButton } from '../../components/BusinessProJoinButton';
import { BecomeFreelancerButton } from '../../components/BecomeFreelancerButton';
import { BusinessWhyFiverrProNavigation } from '../../components/BusinessWhyFiverrProNavigation';
import { BusinessProVisitorProfileDropdown } from '../../components/BusinessProVisitorProfileDropdown';
import { BusinessContactSalesButton } from '../../components/BusinessContactSalesButton';
import { isAllowedFibContact } from '../../utils/isAllowedFibContact';

import styles from './BusinessProVisitor.module.scss';

const BusinessProVisitor = ({ primarySearchVisible = true, currencies: currenciesProp }, { rollouts }) => {
    const pricingData = usePricingDataContext();
    const { currency: userCurrency } = getContext();
    const layoutCurrency = currenciesProp.find(({ code }) => code === userCurrency);
    const currency = { ...layoutCurrency, rate: layoutCurrency.exchange_rate, name: layoutCurrency.code };

    return (
        <Layout className="fiverr-for-business-pro">
            <Row className={classnames(styles.row, 'flex flex-items-center')}>
                <BusinessSidebarTrigger displayFromLG />
                <FiverrBusinessProLinkLogo />
                <BusinessNavSearch
                    className="m-l-24"
                    mode={BusinessNavSearch.MODES.DESKTOP}
                    theme="dark"
                    isVisible={primarySearchVisible}
                />
                <Nav className={styles.nav} displayFromSM>
                    <Nav.Item className={classnames(styles.navItemButton, 'p-r-0 m-r-8')} displayFromLG>
                        <BecomeFreelancerButton />
                    </Nav.Item>
                    <Nav.Item displayFromLG className="p-r-0 m-r-8">
                        <BusinessWhyFiverrProNavigation />
                    </Nav.Item>
                    {isAllowedFibContact() && (
                        <Nav.Item displayFromLG className="p-r-0 m-r-8">
                            <BusinessContactSalesButton />
                        </Nav.Item>
                    )}
                    <Nav.Item displayFromLG className="p-r-0 m-r-20">
                        <BusinessProVisitorProfileDropdown />
                    </Nav.Item>
                    <Nav.Item displayFromSM className="p-r-0">
                        <BusinessProJoinButton />
                    </Nav.Item>
                </Nav>
            </Row>
            <BusinessNavSearch mode={BusinessNavSearch.MODES.MOBILE} theme="dark" isVisible={primarySearchVisible} />
            {/* Footer related drawers */}
            <LazySourcingDomainSelectionDrawer
                currency={currency}
                isPriceUpfrontEnabled={pricingData?.isPriceUpfrontEnabled}
                priceUpfrontConfiguration={pricingData?.priceUpfrontConfiguration}
                priceUpfrontContext={pricingData?.priceUpfrontContext}
            />
            {rollouts?.inLynxesMustangsDmBriefCreationLayoutComponentRollout ? null : (
                <BriefCreationDrawer enableEnhancedUx />
            )}
        </Layout>
    );
};

BusinessProVisitor.propTypes = {
    primarySearchVisible: PropTypes.bool,
    currencies,
};

BusinessProVisitor.contextTypes = {
    rollouts,
};
/**
 * @param {HeaderProps} props
 * @returns {React.ReactElement} Header
 */
export default withContext(BusinessProVisitor);
